import React from 'react';
import './AffiliateProgram.css';

import AffiliatePageTop from '../../components/AffiliatePageComponents/AffiliatePageTop';
import AffiliatePageMiddle from '../../components/AffiliatePageComponents/AffiliatePageMiddle';
import AffiliatePageBottom from '../../components/AffiliatePageComponents/AffiliatePageBottom';
import AffiliatePageContactForm from '../../components/AffiliatePageComponents/AffiliatePageContactForm';


const AFFILIATE_URL = 'https://nakednews.everflowclient.io/affiliate/signup';

function AffiliateProgram() {
  return (
    <React.Fragment>
      <AffiliatePageTop affiliateURL={AFFILIATE_URL} />
      <AffiliatePageMiddle affiliateURL={AFFILIATE_URL} />
      <AffiliatePageBottom />
      <AffiliatePageContactForm />
    </React.Fragment>
  );
}

export default AffiliateProgram;
